import { Component, OnInit } from '@angular/core';
import { ModalController, AlertController, NavParams } from '@ionic/angular';
import * as moment from 'moment-timezone';

@Component({
    selector: 'app-date-time-picker',
    templateUrl: './date-time-picker.page.html',
    styleUrls: ['./date-time-picker.page.scss'],
})
export class DateTimePickerPage implements OnInit {

    moment = moment;
    format = null;
    clear_date = false;

    params = {
        date: null
    };

    constructor(
        public navParams: NavParams,
        public modalController: ModalController,
        public alertController: AlertController,
    ) { }

    ngOnInit() {

        if(this.navParams.get('date')) {
            this.params.date = this.navParams.get('date');
        }
        else {
            this.params.date = this.moment().toISOString(true);
        }

        if(this.navParams.get('format')) {
            this.format = this.navParams.get('format');
        }

        if(this.navParams.get('clear_date')) {
            this.clear_date = this.navParams.get('clear_date');
        }

    }

    close() {
        this.modalController.dismiss();
    }

    selectDate() {
        this.modalController.dismiss(this.params);
    }

    clearDate() {
        this.modalController.dismiss("date_deleted");
    }

}
